// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__36vAE","row":"ProcedureTreatmentSummary_row__3Okpq"};